var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { eventListener } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { isFunction } from '@philips-internal/oswald-ui-utils';
import PhysicianScheduleAppointmentsCardAPI from './physician-schedule-appointments-card-api';
import { ReactComponent as Physician } from '../../assets/images/global/physician.svg';
import './physician-schedule-appointments-card.css';
let PhysicianScheduleAppointmentsCard = class PhysicianScheduleAppointmentsCard extends Component {
    constructor() {
        super(...arguments);
        this.handleClick = () => {
            const { description, onClick, scheduleType, statusItem, } = this.props;
            if (isFunction(onClick)) {
                onClick(new ClickEvent({
                    value: {
                        description,
                        onClick,
                        scheduleType,
                        statusItem,
                    }
                }));
            }
        };
    }
    static { this.propTypes = {
        onClick: eventListener
    }; }
    renderIcon(statusItem) {
        switch (statusItem) {
            default:
                return React.createElement(Physician, null);
        }
    }
    renderContent() {
        const { description, scheduleType, statusItem } = this.props;
        const icon = this.renderIcon(statusItem);
        return (React.createElement("div", { className: 'c-physician-schedule-appointments-card__content' },
            React.createElement("div", { className: 'c-physician-schedule-appointments-card__content-left' },
                React.createElement("div", { className: 'c-physician-schedule-appointments-card__content-icon' }, icon),
                React.createElement("span", { className: 'c-physician-schedule-appointments-card-title' }, scheduleType),
                React.createElement("span", { className: 'c-physician-schedule-appointments-card-subtitle' }, description))));
    }
    renderField() {
        return (this.renderContent());
    }
    render() {
        return (React.createElement("div", { className: 'c-physician-schedule-appointments-card', onClick: () => this.handleClick() }, this.renderField()));
    }
};
PhysicianScheduleAppointmentsCard = __decorate([
    AwesomeComponent({ api: PhysicianScheduleAppointmentsCardAPI, type: ComponentType.DATA_DISPLAY })
], PhysicianScheduleAppointmentsCard);
export default PhysicianScheduleAppointmentsCard;
//# sourceMappingURL=physician-schedule-appointments-card.js.map